import React, { useState, useEffect } from 'react';
import { CustomIcon } from '../../UI';
import './TonuModal.scss';

const TonuModal = ({ 
  isOpen, 
  onClose,
  onSave,
  initialCarrierRate = '',
  initialCustomerRate = ''
}) => {
  const [tonuEnabled, setTonuEnabled] = useState(false);
  const [carrierRate, setCarrierRate] = useState(initialCarrierRate);
  const [customerRate, setCustomerRate] = useState(initialCustomerRate);

  useEffect(() => {
    if (isOpen) {
      setCarrierRate(initialCarrierRate);
      setCustomerRate(initialCustomerRate);
      setTonuEnabled(false);
    }
  }, [isOpen, initialCarrierRate, initialCustomerRate]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
      return () => {
        document.body.classList.remove('modal-open');
      };
    }
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isOpen) {
        handleClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => {
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleSave = () => {
    if (onSave) {
      onSave({
        enabled: tonuEnabled,
        carrierRate: tonuEnabled ? carrierRate : '',
        customerRate: tonuEnabled ? customerRate : '',
      });
    }
    handleClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div 
      className="tonu-modal-overlay" 
      // onClick={handleOverlayClick}
    >
      <div 
        className="tonu-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button 
          className="tonu-modal__close-btn"
          onClick={handleClose}
          aria-label="Close modal"
        >
          <CustomIcon name="close" size={20} />
        </button>

        {/* Title */}
        <h2 className="tonu-modal__title">TONU (Truck Ordered Not Used)</h2>

        {/* TONU Enabled Checkbox */}
        <div className="tonu-modal__checkbox-group">
          <label className="tonu-modal__checkbox-label">
            <input
              type="checkbox"
              checked={tonuEnabled}
              onChange={(e) => setTonuEnabled(e.target.checked)}
              className="tonu-modal__checkbox"
            />
            <span>Apply TONU</span>
          </label>
        </div>

        {/* Rate Fields - Only shown if TONU is enabled */}
        {tonuEnabled && (
          <div className="tonu-modal__rate-fields">
            

            <div className="tonu-modal__form-group">
              <label htmlFor="tonu-customer-rate" className="tonu-modal__label">
                Customer Rate ($)
              </label>
              <input
                type="number"
                id="tonu-customer-rate"
                className="tonu-modal__input"
                value={customerRate}
                onChange={(e) => setCustomerRate(e.target.value)}
                placeholder="0.00"
                onWheel={(e) => e.target.blur()}
              />
            </div>

            <div className="tonu-modal__form-group">
              <label htmlFor="tonu-carrier-rate" className="tonu-modal__label">
                Carrier Rate ($)
              </label>
              <input
                type="number"
                id="tonu-carrier-rate"
                className="tonu-modal__input"
                value={carrierRate}
                onChange={(e) => setCarrierRate(e.target.value)}
                placeholder="0.00"
                onWheel={(e) => e.target.blur()}
              />
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="tonu-modal__actions">
          <button 
            className="tonu-modal__cancel-btn"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button 
            className="tonu-modal__save-btn"
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default TonuModal;




